import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 932px;
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 8px 0;
    text-align: left;
    width: 100%;
  `};
`;

export const Description = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    text-align: left;
    width: 100%;
    strong {
      font-weight: ${theme.v2.font.weights.medium};
    }
    span {
      color: ${theme.v2.colors.brand.primaryMedium};
      font-weight: ${theme.v2.font.weights.medium};
    }
  `};
`;

export const NavWrapper = styled.div`
  display: inline-block;
  margin: 40px 0 32px 0;
  width: 100%;
`;

export const NavbarContainer = styled.div`
  ${({ theme }) => css`
    align-items: end;
    background: ${theme.v2.colors.neutral.highLight};
    border-radius: 8px 8px 0px 0px;
    display: flex;
    padding-top: 8px;
    width: 100%;
  `};
`;

export const NavbarImage = styled.img`
  height: 32px;
  user-select: none;
  -webkit-user-drag: none;
`;

export const DomainInputWrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 0px 0px 8px 8px;
    min-height: 78px;
    padding: 18px 24px;
  `};
`;

export const DomainFieldsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `};
`;

export const TextFieldContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;

    > div > div {
      padding-left: 67px;
      position: relative;
      outline: none;

      &:before {
        color: ${theme.v2.colors.neutral.lowMedium};
        content:'www.';
        font-family: ${theme.v2.font.family.primary};
        font-size: ${theme.v2.font.sizes.xxs};
        font-weight: ${theme.v2.font.weights.regular};
        left: 16px;
        line-height: ${theme.v2.font.lineHeight.text};
        position: absolute;
        top: 18px;
      }
    }

  `};
`;

export const ErrorText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.feedback.problemDark};
    font-size: ${theme.v2.font.sizes.xs};
    margin: -40px 0 40px 0;
    text-align: left;
    width: 100%;
  `};
`;

export const SelectFieldContainer = styled.div`
  ${({ theme }) => css`
    min-width: 280px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      min-width: auto;
    }
  `};
`;

export const OptionsWrapper = styled.ul`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
    list-style-type: none;
    margin: 40px 0px 0px 0px;
    width: 100%;
    max-width: 930px;
    max-height: 430px;
    overflow: auto;
    padding: 0px;
    align-items: stretch;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 24px 0px 0px 0px;
    }

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highMedium};
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${theme.v2.colors.neutral.highMedium};
    }
  `}
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    width: 100%;
    border: 1px solid ${theme.v2.colors.neutral.highMedium};
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;

    &.checked{
      border-color: ${theme.v2.colors.brand.primaryBlue};
    }
  `};
`;

export const RadioLabel = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OptionRow = styled.div`
  ${() => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    
    button {
      padding: 2.5px;
    }
  `}
`;

export const OptionTitle = styled.div`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    margin: 0 0 0 24px;
    text-align: left;
    word-break: break-all;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16px 0;
  `};
`;

export const OptionSubTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    word-break: break-all;
    display: block;
    text-align: left;
  `};
`;

export const CheckboxLabel = styled.div`
  ${({ theme }) => css`
  display: flex;
  gap: 4px;
  justify-content: start;
  cursor: pointer;
  label {
    border-radius: 6px !important;
    border-color: ${theme.v2.colors.neutral.lowLight} !important;
  }
  width: 100%;
  `};
`;

export const CheckboxDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    text-align: left;
  `};
`;

export const Disclaimer = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    text-align: left;
    padding-top: 60px;
    width: 100%;
  `};
`;

export const TagLabel = styled.div`
  display: flex;
  justify-content: space-between;
`;
